import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_REQUESTFORQUOTATION } from "../../../../utils/constants";
import { RFQInterface } from "../../../../models/ProcurementModule/RequestForQuotation";

interface UpdateRFQContext {
  previousRFQ: RFQInterface[];
}

interface UpdateDocumentUrlInput {
  id: string;
  documentUrl: string;
}

const useAddDocGenRFQ = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateDocumentUrlInput, UpdateRFQContext>({
    // No mutationFn needed if there's no server call
    mutationFn: async () => {
      return; // optional noop
    },

    onMutate: async ({ id, documentUrl }) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
      });

      const previousRFQ =
        queryClient.getQueryData<RFQInterface[]>([
          CACHE_KEY_REQUESTFORQUOTATION,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<RFQInterface[]>(
        [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
        (data = []) =>
          data.map((item) => (item.id === id ? { ...item, documentUrl } : item))
      );

      return { previousRFQ };
    },

    onError: (_error, _variables, context) => {
      if (!context) return;

      queryClient.setQueryData<RFQInterface[]>(
        [CACHE_KEY_REQUESTFORQUOTATION, page, pageSize],
        context.previousRFQ
      );
    },
  });
};

export default useAddDocGenRFQ;
